import React from "react";

const StatusBadge = ({ status }) => {
  const statusConfig = {
    active: { color: "bg-green-100 text-green-800 border border-green-200", text: "Active" },
    inactive: { color: "bg-red-100 text-red-800 border border-red-200", text: "Inactive" },
    pending: { color: "bg-amber-100 text-amber-800 border border-amber-200", text: "Pending" },
    approved: { color: "bg-green-100 text-green-800 border border-green-200", text: "Approved" },
    rejected: { color: "bg-red-100 text-red-800 border border-red-200", text: "Rejected" },
    allowed: { color: "bg-blue-100 text-blue-800 border border-blue-200", text: "Allowed" }
  };

  const config = statusConfig[status] || statusConfig.active;

  return (
    <span className={`px-3 py-1 rounded-full text-xs font-medium ${config.color}`}>
      {config.text}
    </span>
  );
};

export default StatusBadge;